import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/Servicepg.css'; // Reuse the same styles unless you want to customize

import serviceVideo from '../assets/mc-bg-vid.mp4';
import img1 from '../assets/building.jpg';
import img2 from '../assets/mc-5.jpg';
import img3 from '../assets/mc-4.jpg';
import img4 from '../assets/mc-9.webp';
import img5 from '../assets/mc-12.jpg';

const Mechpg = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
     <div className="servicepg-container">
      <video className="background-video" autoPlay muted loop playsInline>
        <source src={serviceVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="servicepg-content">
        <motion.div
          className="servicepg-left"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <h1>MECHANICAL SERVICES</h1>
          <p>
            We specialize in precision AutoCAD drafting and detailed mechanical design services.
            Our team delivers piping, structural layouts, and more —
            tailored for industrial and commercial applications.
          </p>
        </motion.div>

        <motion.div
          className="servicepg-right"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <div className="image-merge-container">
            <img className="merged-img img1" src={img1} alt="Mechanical 1" />
            <img className="merged-img img2" src={img2} alt="Mechanical 2" />
            <img className="merged-img img3" src={img3} alt="Mechanical 3" />
            <img className="merged-img img4" src={img4} alt="Mechanical 4" />
            <img className="merged-img img5" src={img5} alt="Mechanical 5" />
          </div>
        </motion.div>
      </div>
    </div>
    </>
  );
};

export default Mechpg;
